module.exports = __webpack_public_path__ + "static/img/ticketExample.b395ae4.png";